module.exports = __webpack_public_path__ + "static/media/logo-uj1.0901721d.png";